import OpenDialog from "./OpenDialog";

export default {
  OpenDialog,
};
